import { Skeleton, Stack } from "@mui/material";
import { MAX_WIDTH_OBJ } from '../../config/cacheKey';

const CreateNewRequestSkeleton = () => {

    return (
        <>
            <Stack spacing={1}>
                {/* For variant="text", adjust the height via font-size */}
                <Skeleton variant="rectangular" style={{margin: "auto ",marginTop:"40px",marginLeft:"20px",marginRight:"20px"}}  height={40} />

                <Skeleton variant="rectangular" style={{margin: "auto ",marginTop:"20px",marginLeft:"20px",marginRight:"20px"}} height={80} />
                <Skeleton variant="rectangular" style={{margin: "auto " ,marginTop:"20px",marginLeft:"20px",marginRight:"20px"}}  height={80} />
                <Skeleton variant="rectangular" style={{margin: "auto ",marginTop:"20px",marginLeft:"20px",marginRight:"20px"}}  height={40} />
                <Skeleton variant="rectangular"  style={{margin: "auto ",marginTop:"20px",marginLeft:"20px",marginRight:"20px"}}  height={120} />
                <Skeleton variant="rectangular" style={{margin: "auto ",marginTop:"20px",marginLeft:"20px",marginRight:"20px"}}  height={40} />

            </Stack></>
    )
}

export default CreateNewRequestSkeleton;